module.exports = __webpack_public_path__ + "static/devils-tea-36d46be5cc319f23494592816ce3cd73.jpg";